"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var libzl_1 = require("../libzl");
var IdleInfo = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    z-index: 10;\n    position: absolute;\n    width: 100%;\n    height:100%;\n    background-color: transparent;\n    pointer-events: none;\n"], ["\n    z-index: 10;\n    position: absolute;\n    width: 100%;\n    height:100%;\n    background-color: transparent;\n    pointer-events: none;\n"])));
var IdleImg = styled_components_1.default.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    transition: opacity 0.5s ease-in-out;\n    opacity: ", ";\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 120px;\n    height: 120px;\n    @media ", "{\n        width: 84px;\n        height: 84px;\n    }\n    transform: translate(-50%, -50%);\n    border-radius: 8px;\n"], ["\n    transition: opacity 0.5s ease-in-out;\n    opacity: ", ";\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 120px;\n    height: 120px;\n    @media ", "{\n        width: 84px;\n        height: 84px;\n    }\n    transform: translate(-50%, -50%);\n    border-radius: 8px;\n"])), function (props) { return props.show ? "0.75" : "0"; }, function (props) { return props.theme.breakpoints.S; });
var IdleIndicator = /** @class */ (function (_super) {
    __extends(IdleIndicator, _super);
    function IdleIndicator(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showMe: false,
            zlready: false,
            twoD: false,
            showCounter: 0
        };
        return _this;
    }
    IdleIndicator.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.zlbolt === undefined && this.props.zlbolt) {
            libzl_1.initIdleIndicator(this, this.props.zlbolt);
        }
    };
    IdleIndicator.prototype.render = function () {
        return (react_1.default.createElement(IdleInfo, null,
            react_1.default.createElement(IdleImg, { show: this.state.showMe && this.state.showCounter === 1, src: this.state.twoD ? this.props.theme.icons.cue2d : this.props.theme.icons.cue3d, alt: "interactive scene" })));
    };
    return IdleIndicator;
}(react_1.Component));
exports.default = styled_components_1.withTheme(IdleIndicator);
var templateObject_1, templateObject_2;
//# sourceMappingURL=IdleIndicator.js.map